import {
  FETCH_APPOINTEES,
  NEW_APPOINTEE,
  UPDATE_APPOINTEE,
  DELETE_APPOINTEE
} from "../../actions/types";

const initialState = {
  items: [],
  item: {},
  itemUpdated: {},
  itemDel: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_APPOINTEES:
      return {
        ...state,
        items: action.payload
      };

    case NEW_APPOINTEE:
      return {
        ...state,
        item: action.payload
      };

    case UPDATE_APPOINTEE:
      return {
        ...state,
        itemUpdated: action.payload
      };

    case DELETE_APPOINTEE:
      return {
        ...state,
        itemDel: action.payload
      };

    default:
      return state;
  }
}
